/*
 * @Author: zhou wei
 * @Date: 2024-08-09 10:51:04
 * @Description:
 */
import React, { useEffect, memo, useState } from 'react';
import { Loader } from '@ok/okd';
import { subscribe } from '@ok/blade';
import { get } from '@common/utils/dataProxy';
import URL from '@pages/currencyInfo/common/URL';
import { Create } from '@pages/index/utils/views';
import { EVENT_EMITTER_KEYS } from '@pages/currencyInfo/common/context';
import { Charts } from '@ok/okj-common';
import styles from './index.module.less';

const ChartWrapper = memo(({ currencyId, type, isMinus }) => {
  const [chartData, setChartData] = useState([]);
  const [quotePrecision, setQuotePrecision] = useState(0);
  const [showLoading, setShowLoading] = useState(false);
  useEffect(() => {
    setShowLoading(true);
    get(URL.GET_CURRENCY_CANDLES_DATA, {
      currencyId,
      type: type.id,
    })
      .then((res) => {
        if (res?.length) {
          const latest = res.length - 1;

          const latestChartData = res[latest];
          subscribe.trigger(EVENT_EMITTER_KEYS.currencyPrice, {
            price: latestChartData[1],
            quotePrecision: latestChartData[4],
          });
        }
        setQuotePrecision(res[0][4]);
        const dataSource = res.map(([time, value, volume]) => [
          new Date(time).getTime(),
          value,
          volume,
        ]);
        setChartData(dataSource);
        setShowLoading(false);
      })
      .catch(() => {
        setShowLoading(false);
      });
    return () => {};
  }, [currencyId, type, isMinus]);

  return (
    <div className={styles['chart-wrapper']}>
      <Create when={chartData.length !== 0}>
        <Charts
          chartData={chartData}
          isMinus={isMinus}
          quotePrecision={quotePrecision}
        />
      </Create>
      <Create when={showLoading}>
        <Loader.Circle
          className={styles['chart-loader']}
          type={Loader.TYPE.primary}
          hasMask
        />
      </Create>
    </div>
  );
});

export default ChartWrapper;
